export default "https://cdn-static.gokick.com/assets/31bbee86f9627d9d8b331552e0c9ca66f3d2b554/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";